import { footerNavGroups } from '@/config/nav'
import { siteConfig } from '@/config/site'
import { Container } from '@/components/common/container'
import { NavLink } from '@/components/layout/nav-link'

function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-border border-t">
      <Container className="py-12">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          <div className="col-span-2 sm:col-span-1">
            <span className="text-foreground text-sm font-semibold tracking-tight">
              {siteConfig.name}
            </span>
            <p className="text-muted-foreground mt-2 text-sm">{siteConfig.description}</p>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-foreground text-sm font-medium">{group.title}</h3>
              <ul className="mt-3 space-y-2">
                {group.items.map((item) => (
                  <li key={item.href}>
                    <NavLink to={item.href} className="text-sm">
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-border text-muted-foreground mt-10 border-t pt-6 text-sm">
          © {year} {siteConfig.name}. All rights reserved.
        </div>
      </Container>
    </footer>
  )
}

export { Footer }
